<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      <ion-button (click)="modalController.dismiss()">
        {{ 'core.done' | translate }}
      </ion-button>
    </ion-buttons>

    <ion-title>{{ 'push-notification.title' | translate }}</ion-title>

    <ion-buttons slot="secondary">
      @if (((pushNotifications$ | async)?.length ?? 0) > 0) {
        <ion-button slot="icon-only" (click)="clearNotifications()">
          <ion-icon name="trash"></ion-icon>
        </ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (((pushNotifications$ | async)?.length ?? 0) === 0) {
    <app-no-content icon="assets/wizard/icon-badge.svg">
      <ng-template #header>{{ 'push-notification.empty' | translate }}</ng-template>
    </app-no-content>
  }

  @for (pushNotification of (pushNotifications$ | async) ?? []; track pushNotification.id) {
    <ion-card>
      <ion-card-header>
        <ion-card-title class="title">
          @if (pushNotification.title) {
            {{ pushNotification.title}}
          } @else {
            {{ pushNotification.data.title }}
          }
        </ion-card-title>

        <ion-card-subtitle class="flex flex-row ion-justify-content-between">
          <div class="flex gap-1 ion-align-items-center">
            @switch (pushNotification.data.topic) {
              @case ('GENERAL') {
                <ion-icon name="notifications" size="small" slot="start" aria-hidden="true"></ion-icon>
              }
              @case ('UNICARD') {
                <ion-icon name="card" size="small" slot="start" aria-hidden="true"></ion-icon>
              }
              @case ('SPORTS') {
                <ion-icon src="assets/push-notification/sports.svg" size="small" slot="start" aria-hidden="true"></ion-icon>
              }
              @case ('LIBRARY') {
                <ion-icon src="assets/push-notification/library.svg" size="small" slot="start" aria-hidden="true"></ion-icon>
              }
              @case ('TIMETABLE') {
                <ion-icon src="assets/push-notification/timetable.svg" size="small" slot="start" aria-hidden="true"></ion-icon>
              }
              @case ('HEALTH_PASSPORT') {
                <ion-icon src="assets/push-notification/health-passport.svg" size="small" slot="start" aria-hidden="true"></ion-icon>
              }
            }
            {{ 'settings.push.channel.' + ((pushNotification.data.topic | lowercase) || 'default') | translate }}
          </div>

          @if (pushNotification.data.date) {
            <div class="flex flex-row ion-align-items-center gap-1">
              {{ pushNotification.data.date | date:'short':'CET':'de-DE' }}
              <ion-icon size="small" name="time"></ion-icon>
            </div>
          }
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        @if (pushNotification.body) {
            {{ pushNotification.body }}
        } @else {
            {{ pushNotification.data.body }}
        }
      </ion-card-content>

      <ion-button fill="clear" color="medium" (click)="delete(pushNotification.id)">
        <ion-icon name="trash"></ion-icon>
        {{ 'core.delete' | translate }}
      </ion-button>
    </ion-card>
  }
</ion-content>
